import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Tailwind-aware className combiner. Re-homed from the per-app `@/lib/utils`
 * so the shared design-system primitives (and every portal module rendering
 * with them) have ONE canonical `cn` instead of an app-local copy.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
